{
  "name": "@smarter.sh/ui-chat",
  "version": "0.39.0",
  "description": "chatbot React.js component for the https://smarter.sh declarative, plugin-based AI resource management platform.",
  "homepage": "https://smarter.sh",
  "type": "module",
  "main": "./dist/smarter-chat-library.umd.js",
  "module": "./dist/smarter-chat-library.es.js",
  "types": "./dist/types/src/index.d.ts",
  "jsdelivr": "./dist/embed.js",
  "unpkg": "./dist/embed.js",
  "exports": {
    ".": {
      "types": "./dist/types/src/index.d.ts",
      "import": "./dist/smarter-chat-library.es.js",
      "require": "./dist/smarter-chat-library.umd.js"
    },
    "./dist/ui-chat.css": "./dist/ui-chat.css",
    "./style.css": "./dist/ui-chat.css",
    "./embed": "./dist/embed.js",
    "./dist/embed.js": "./dist/embed.js"
  },
  "files": [
    "dist"
  ],
  "sideEffects": [
    "*.css"
  ],
  "keywords": [
    "react",
    "component",
    "chatbot",
    "ai",
    "smarter"
  ],
  "author": "Lawrence McDaniel <lpm0073@gmail.com>, (https://lawrencemcdaniel.com/)",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/smarter-sh/smarter.git",
    "directory": "smarter/react/packages/smarter.sh-chat"
  },
  "bugs": {
    "url": "https://github.com/smarter-sh/smarter/issues"
  },
  "contributors": [
    "Lawrence McDaniel <lpm0073@gmail.com> (https://lawrencemcdaniel.com/)"
  ],
  "engines": {
    "node": ">=20.17.0",
    "npm": ">=10.8.2"
  },
  "funding": {
    "type": "individual",
    "url": "https://github.com/sponsors/lpm0073"
  },
  "scripts": {
    "dev": "NODE_ENV=dev && vite",
    "build": "tsc -b && npm run build:lib && npm run build:embed",
    "build:lib": "vite build --mode lib && tsc -p tsconfig.lib.json",
    "contract:types": "node scripts/contract-types.mjs",
    "i18n": "node scripts/i18n.mjs",
    "lint": "eslint --max-warnings=0 .",
    "preview": "vite preview",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build",
    "typecheck": "tsc -b",
    "test": "vitest run",
    "test:watch": "vitest",
    "prepublishOnly": "npm run build:lib && npm run build:embed",
    "coverage": "vitest run --coverage --config vitest.coverage.config.ts",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "build:embed": "vite build --mode embed && vite build --mode embed-mermaid",
    "check:dist": "node scripts/check-dist.mjs"
  },
  "dependencies": {
    "@chatscope/chat-ui-kit-react": "^2.1.1",
    "@chatscope/chat-ui-kit-styles": "^1.4.0",
    "dompurify": "^3.4.16",
    "highlight.js": "^11.12.0",
    "katex": "^0.18.7",
    "marked": "^14.0.0",
    "mermaid": "^11.17.2"
  },
  "peerDependencies": {
    "react": "^19",
    "react-dom": "^19"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@storybook/addon-a11y": "^10.6.1",
    "@storybook/addon-docs": "^10.6.1",
    "@storybook/react-vite": "^10.6.1",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.7",
    "@types/node": "^26.6.3",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.1",
    "@vitest/coverage-v8": "^5.0.3",
    "@vitest/eslint-plugin": "^1.6.27",
    "ajv": "^8.20.0",
    "bootstrap": "^5.3.8",
    "bootstrap-icons": "^1.13.1",
    "eslint": "^10.11.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-jest-dom": "^5.10.1",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.5.7",
    "eslint-plugin-storybook": "^10.6.1",
    "eslint-plugin-testing-library": "^7.16.2",
    "globals": "^17.13.0",
    "jsdom": "^30.1.2",
    "json-schema-to-typescript": "^15.0.4",
    "msw": "^2.15.0",
    "prettier": "^3.9.9",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "storybook": "^10.6.1",
    "typescript": "~6.0.2",
    "typescript-eslint": "^8.71.0",
    "vite": "^8.3.2",
    "vitest": "^5.0.3"
  },
  "msw": {
    "workerDirectory": [
      ".storybook/public"
    ]
  },
  "overrides": {
    "eslint-plugin-jsx-a11y": {
      "eslint": "$eslint"
    }
  },
  "publishConfig": {
    "access": "public"
  }
}
